import { render, staticRenderFns } from "./CustomerReportTabCreditTransactions.vue?vue&type=template&id=299aef54&scoped=true"
import script from "./CustomerReportTabCreditTransactions.vue?vue&type=script&lang=js"
export * from "./CustomerReportTabCreditTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299aef54",
  null
  
)

export default component.exports